module.exports = __webpack_public_path__ + "img/subject-14.2aa095e5.svg";